var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1797 32H44.1797",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1797 23.25H44.1797",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6797 44.5L22.9297 49.5",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6797 44.5L40.4297 49.5",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4297 17H22.9297C20.8586 17 19.1797 18.6789 19.1797 20.75V40.75C19.1797 42.8211 20.8586 44.5 22.9297 44.5H40.4297C42.5008 44.5 44.1797 42.8211 44.1797 40.75V20.75C44.1797 18.6789 42.5008 17 40.4297 17Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6797 23.25V32",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8047 40.75C25.8402 40.75 26.6797 39.9105 26.6797 38.875C26.6797 37.8395 25.8402 37 24.8047 37C23.7692 37 22.9297 37.8395 22.9297 38.875C22.9297 39.9105 23.7692 40.75 24.8047 40.75Z",
    fill: "#0256B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5547 40.75C39.5902 40.75 40.4297 39.9105 40.4297 38.875C40.4297 37.8395 39.5902 37 38.5547 37C37.5192 37 36.6797 37.8395 36.6797 38.875C36.6797 39.9105 37.5192 40.75 38.5547 40.75Z",
    fill: "#0256B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.218ddaacd557cf1195a1c5aaf465269f.svg";
export { ForwardRef as ReactComponent };